// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__tnOSp","checkboxCol":"Table_checkboxCol__1LbLi","emailCol":"Table_emailCol__3g-fa","actionCol":"Table_actionCol__1oCXb"};